"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HEADER_SKELETON = void 0;
const HEADER_SKELETON = exports.HEADER_SKELETON = 'header-skeleton';
